export default __webpack_public_path__ + "3bdab8d.png";